export const DIALOG_PANEL_HEADER_HEIGHT = 40;
export const DIALOG_PANEL_FOOTER_HEIGHT = 48;
export const DIALOG_WIDTH = 336;
export const DIALOG_HEIGHT = 595;

export const APPEARANCE_TAB_ID = 'appearance';
export const INDETERMINATE = 'indeterminate';
